<template>
  <ViewForm />
</template>
<script>
import ViewForm from './components/ViewForm.vue';
export default {
  name: 'SettingTenantAdd',
  components: {
    ViewForm,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},

  mounted() {},
  methods: {},
};
</script>
